import HttpService from './HttpService';

const API_URL = '/onboarding';

/**
 * Default onboarding status when API is unavailable.
 * Shows all milestones as incomplete so users see the getting started guide.
 */
const DEFAULT_STATUS = {
  milestones: {
    first_house: { completed: false, completed_at: null },
    first_item: { completed: false, completed_at: null },
    first_item_scan: { completed: false, completed_at: null },
    first_room_scan: { completed: false, completed_at: null },
    first_document: { completed: false, completed_at: null }
  }
};

const OnboardingService = {
  /**
   * Get onboarding milestone status for the current user.
   * Returns default status (all incomplete) on error to ensure
   * users always see the getting started guide.
   * @returns {Promise<Object>} - Milestone completion status
   */
  getStatus: async () => {
    try {
      const response = await HttpService.get(`${API_URL}/status`);
      return response.data;
    } catch (error) {
      console.error('Error fetching onboarding status, using defaults:', error);
      // Return default status so onboarding cards still appear
      return DEFAULT_STATUS;
    }
  },

  /**
   * Get the default status (useful for loading states)
   * @returns {Object} - Default milestone status with all incomplete
   */
  getDefaultStatus: () => {
    return DEFAULT_STATUS;
  }
};

export default OnboardingService;
